import { render, staticRenderFns } from "./SettingModal.vue?vue&type=template&id=175427db&scoped=true&"
import script from "./SettingModal.vue?vue&type=script&lang=js&"
export * from "./SettingModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175427db",
  null
  
)

export default component.exports